/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Closedeal_Modaldescription3Inputs */

const en_coinvestments_tracking_closedeal_modaldescription3 = /** @type {(inputs: Coinvestments_Tracking_Closedeal_Modaldescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to close this opportunity? This will prevent further edits to Organisation and internal amounts.`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to close this opportunity? This will prevent further edits to Organisation and internal amounts." |
*
* @param {Coinvestments_Tracking_Closedeal_Modaldescription3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_closedeal_modaldescription3 = /** @type {((inputs?: Coinvestments_Tracking_Closedeal_Modaldescription3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Closedeal_Modaldescription3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_closedeal_modaldescription3(inputs)
});
export { coinvestments_tracking_closedeal_modaldescription3 as "coInvestments_tracking_closeDeal_modalDescription" }